import {editSubAdminFields} from "../../../company/CompanyAccountProfile/consts.jsx";

export const editSubAdminPhoneHideFormFields = [
    editSubAdminFields.allowedPaymentsMethods,
    editSubAdminFields.allowedServices,
    editSubAdminFields.department,
    editSubAdminFields.manageDepartments,
    editSubAdminFields.email,
    editSubAdminFields.firstName,
    editSubAdminFields.fullAddress,
    editSubAdminFields.budget,
    editSubAdminFields.isMustProvidePurchaseOrderNumber
];
